import { classes as i } from "../classes/classes.js";
import '../assets/InputLabel.css';const o = "op_input_Oo4YV", r = "op_label_i0KuK", m = "op_IDlabelsInputs_rDETH", c = {
  input: o,
  label: r,
  IDlabelsInputs: m
}, { useId: b, Children: d } = wp.element;
function R(t) {
  return /* @__PURE__ */ React.createElement("input", { ...t, className: i(c.input, t == null ? void 0 : t.className) });
}
function E(t) {
  const {
    children: a = "Add label..."
  } = t;
  return /* @__PURE__ */ React.createElement("label", { ...t, className: i(c.label, t == null ? void 0 : t.className) }, a);
}
function _(t) {
  const {
    children: a = []
  } = t, n = manageAttributeCssClasses({ defaultClasses: c.IDlabelsInputs, attributes: t });
  return /* @__PURE__ */ React.createElement("span", { ...n }, /* @__PURE__ */ React.createElement(f, null, a));
}
function f(t) {
  const {
    children: a = []
  } = t, n = b();
  return d.map(a, (l, p) => {
    let e = l.type;
    if (typeof e == "function") {
      let s = l.type(l.props), { type: u } = s;
      return u == "label" && (s.props.htmlFor = n), u == "input" && (s.props.id = n), s;
    }
    return (e == "label" || (e == null ? void 0 : e.name) == "Label") && (l.props.htmlFor = n), (e == "input" || (e == null ? void 0 : e.name) == "Input" || (e == null ? void 0 : e.name) == "SelectComponent" || (e == null ? void 0 : e.name) == "ResponsiveRadioSelectChooser") && (l.props.id = n), /* @__PURE__ */ React.createElement(
      e,
      {
        ...l.props
      }
    );
  });
}
export {
  f as AddIDs,
  _ as IDlabelsInputs,
  R as Input,
  E as Label
};
